import { render, staticRenderFns } from "./areaVue.vue?vue&type=template&id=e8fbd41a&scoped=true&"
import script from "./areaVue.vue?vue&type=script&lang=js&"
export * from "./areaVue.vue?vue&type=script&lang=js&"
import style0 from "./areaVue.vue?vue&type=style&index=0&id=e8fbd41a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fbd41a",
  null
  
)

export default component.exports